"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinalNegotiationParticipant = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const final_negotiation_meeting_summary_entity_1 = require("./final-negotiation-meeting-summary.entity");
const employee_entity_1 = require("./employee.entity");
let FinalNegotiationParticipant = class FinalNegotiationParticipant {
    constructor(id, meetingSummaryId, participantId) {
        this.id = id;
        this.meetingSummaryId = meetingSummaryId;
        this.participantId = participantId;
    }
};
exports.FinalNegotiationParticipant = FinalNegotiationParticipant;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], FinalNegotiationParticipant.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "meeting_summary_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], FinalNegotiationParticipant.prototype, "meetingSummaryId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => final_negotiation_meeting_summary_entity_1.FinalNegotiationMeetingSummary, (meeting) => meeting.participants, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "meeting_summary_id" }),
    tslib_1.__metadata("design:type", Object)
], FinalNegotiationParticipant.prototype, "meetingSummary", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "participant_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], FinalNegotiationParticipant.prototype, "participantId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => employee_entity_1.Employee, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "participant_id" }),
    tslib_1.__metadata("design:type", Object)
], FinalNegotiationParticipant.prototype, "participant", void 0);
exports.FinalNegotiationParticipant = FinalNegotiationParticipant = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "final_negotiation_participant_map" }),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number])
], FinalNegotiationParticipant);
